import React from 'react';
import classes from './DataTable.module.css';
import { TableHeader } from './TableHeader/TableHeader';
import { TableRow } from './TableRow/TableRow';
import { TableProps } from './types';
import { SimpleTableHeader } from './SimpleTableHeader/SimpleTableHeader';
import { SimpleTableRow } from './SimpleTableRow/SimpleTableRow';

const DataTable = <T, F = any, K = undefined>({
  columns,
  nestedColumns,
  nestedRowsKey,
  nestedIndex = 1,
  rows,
  Toolbar,
  footer,
  simple,
  rowStyle = {},
  cellStyle = {},
  expandedRows = [],
  onExpandClick,
  isDownloading = false,
}: TableProps<T, F, K>) => {
  return (
    <div className={classes.container}>
      {Toolbar && <Toolbar />}
      <table className={classes.table} border={0} cellSpacing={0}>
        {simple ? (
          <SimpleTableHeader columns={columns} />
        ) : (
          <TableHeader<T> columns={columns} canExpand={!!onExpandClick} />
        )}
        <tbody className={classes.tbody}>
          {rows.map((row, index) =>
            simple ? (
              <SimpleTableRow<T>
                key={index}
                columns={columns}
                row={row}
                index={index}
                style={rowStyle}
                cellStyle={cellStyle}
                isDownloading={isDownloading}
              />
            ) : (
              <React.Fragment key={index}>
                <TableRow<T>
                  key={index}
                  columns={columns}
                  row={row}
                  index={index}
                  style={rowStyle}
                  cellStyle={cellStyle}
                  onExpandClick={onExpandClick}
                  isExpanded={expandedRows?.includes(index)}
                />
                {expandedRows.includes(index) && (
                  <>
                    {nestedColumns && nestedRowsKey && (
                      <TableHeader<K>
                        columns={nestedColumns}
                        nestedHeader
                        nestedIndex={nestedIndex}
                        canExpand={!!onExpandClick}
                      />
                    )}
                    {nestedColumns &&
                      nestedRowsKey &&
                      (row[nestedRowsKey] as K[]).map((nestedColumn, _index) => {
                        return (
                          <TableRow<K>
                            nestedCell
                            key={`${index}_${_index}`}
                            row={nestedColumn}
                            columns={nestedColumns}
                            index={index}
                          />
                        );
                      })}
                  </>
                )}
              </React.Fragment>
            )
          )}
        </tbody>
        {footer && (
          <tfoot className={classes.tableFootStyle}>
            <TableRow<F> index={-1} columns={footer.columns} row={footer.data} />
          </tfoot>
        )}
      </table>
    </div>
  );
};

export { DataTable };
